import client from '../client'

export const getDecodeMakesKey = `${process.env.NEXT_PUBLIC_INTEGRATION_DATAKIOSK_ENDPOINT}/GetDecodeMakes`

export async function getDecodeMakes({ year }) {
  const params = new URLSearchParams({ year: year.toString() })

  return client(`${getDecodeMakesKey}?${params.toString()}`)
}
